var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"right"},[_c('div',{staticClass:"count",class:'text-' + _vm.color},[_vm._v(_vm._s(_vm.count))]),_c('div',{staticClass:"value",class:_vm.color},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }